import React from "react";
import AppBar from "../../components/DefaultAppBar";
import TicketForm from "./TicketForm";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import Box from "@mui/material/Box";

export const route = "/tickets/new";

const TicketFormContainer = () => {
  return (
    <Box sx={{ position: "relative", pt: 2, pb: 7 }}>
      <AppBar>
        <LocationFilterToolbar noTicketFilter />
      </AppBar>
      <TicketForm />
    </Box>
  );
};

TicketFormContainer.route = route;

export default TicketFormContainer;
